export const stemiDetailsTranslations = {
    en: {
        personalDetails: "Personal Details",
        healthCamp: "Health Camp:",
        tokenNo: "Token No:",
        beneficiaryName: "Beneficiary Name:",
        campDate: "Camp Date:",
        createdBy: "Created By:",

        vitalSigns: "Vital Signs",
        bloodPressure: "Blood Pressure:",
        respiratoryRate: "Respiratory Rate:",
        spo2: "SPO2:",
        heartRate: "Heart Rate:",

        clinicalDetails: "Clinical Details",
        presentingSymptoms: "Presenting Symptoms:",
        ecgFindings: "ECG Findings:",
        remark: "Remark:",

        documents: "Documents",
        notAvailable: "N/A"
    },
    mr: {
        personalDetails: "वैयक्तिक तपशील",
        healthCamp: "आरोग्य शिबिर:",
        tokenNo: "टोकन क्रमांक:",
        beneficiaryName: "लाभार्थीचे नाव:",
        campDate: "शिबिर तारीख:",
        createdBy: "तयार केले:",

        vitalSigns: "जीवनचिन्हे",
        bloodPressure: "रक्तदाब:",
        respiratoryRate: "श्वसन दर:",
        spo2: "SPO2:",
        heartRate: "हृदय गती:",

        clinicalDetails: "क्लिनिकल तपशील",
        presentingSymptoms: "सादर लक्षणे:",
        ecgFindings: "ECG निष्कर्ष:",
        remark: "टिप्पणी:",

        documents: "कागदपत्रे",
        notAvailable: "उपलब्ध नाही"
    }
};
